import {observer} from "mobx-react-lite"
import valueOutput from "../../store/entities/ValueOutput"
import ReactTooltip from "react-tooltip"
import React from "react"
import { HashLink } from "react-router-hash-link"
import {appPages} from "../../App";

const builtinDescriptions = ["ozonPriceMarkupSetup"]
export const DestinationDescription = observer(({destination}: { destination: valueOutput }) => {
    let description: any = destination.description;
    if (!description) {
        return null
    }
    if (builtinDescriptions.includes(description)) {
        if (description === "ozonPriceMarkupSetup") {
            description = <>Для настройки наценки перейдите в раздел <HashLink to={appPages.priceSync + "#price_markup"}>"Обновление цен"</HashLink> </>
        }
    }

    return <div style={{display: "inline-flex", alignItems: "center", marginLeft: "10px", color: "var(--light-gray)"}}>
            <p className="large custom-my-0" data-tip={true} data-for={destination.ozon_attribute_id + destination.type}>
                <i className={"far fa-question-circle"}/>
            </p>
            <ReactTooltip
                className="extraClass"
                id={destination.ozon_attribute_id + destination.type}
                effect="solid"
                delayHide={500}
            >
                <div style={{maxWidth: "300px"}}>
                    {description}
                </div>
            </ReactTooltip>
        </div>
})